import React from 'react';

export default () => (
  <div id="backbone-contents" className="backbone-contents">
    <div className="site-main-content-wrapper">
      <div id="site-header-title" />
      <div id="contents" />
    </div>
  </div>
);

// The purpose of this element is to act as holder of the backbone views
// And tabs manager (site-header-title)
// All base views render to this element, so we keep it until fully migrated
// Will add a ref to the whole container in the future so when a page is rendered by react
// The backbone contents is hidden and the way around, to be done in next sub-tasks
